import React from 'react';
import { useSingleSaleTableTotalStyles } from 'components/Payments/SingleSale/Table/Total/SingleSaleTableTotal.styles';
import { Typography } from '@material-ui/core';
import { useCommonStyles } from 'components/UI/CommonStyles';
import CalculatingSpinner from 'components/UI/CalculatingSpinner';
import { Order } from '@spike/order-model';
import clsx from 'clsx';

interface SingleSaleTotalsProps {
    order: Order;
    calculating?: boolean;
    className?: string;
}

export const SingleSaleTableTotal: React.FC<SingleSaleTotalsProps> = props => {
    const commonClasses = useCommonStyles();
    const classes = useSingleSaleTableTotalStyles();

    const orderSubtotal = React.useMemo(() => {
        return [...props.order.items.products, ...props.order.items.addOnServices, ...props.order.items.customs]
            .reduce((acc, item) => {
                return acc + Number(item.orderItem.total);
            }, 0)
            .toFixed(2);
    }, [props.order.items]);

    return (
        <>
            <div className={clsx(classes.container, props.className)}>
                <div className={clsx(commonClasses.flexRow, classes.boxTotal, classes.line)}>
                    <Typography className={commonClasses.typo18_600}>Sub Total</Typography>
                    {props.calculating ? (
                        <CalculatingSpinner />
                    ) : (
                        <Typography className={commonClasses.typo18_600}>${orderSubtotal}</Typography>
                    )}
                </div>

                {/*<div className={clsx(commonClasses.flexRow, classes.boxTotal, classes.line)}>
                    <Typography className={commonClasses.typo18_400}>Tax</Typography>
                    {props.calculating ? <CalculatingSpinner/> : <Typography className={commonClasses.typo18_400}>${props.invoice.tax.amount}</Typography>}
                </div>*/}

                {/* <div>
                    {Object.entries(props.invoice.tax.detail).map(entry => {
                        const [key, value] = entry;

                        return (
                            <div
                                key={key}
                                className={clsx(commonClasses.flexRow, classes.boxTotal, classes.line)}
                            >
                                <Typography className={commonClasses.typo18_400}>{key}</Typography>
                                {props.calculating ? (
                                    <CalculatingSpinner />
                                ) : (
                                    <Typography className={commonClasses.typo18_400}>${value}</Typography>
                                )}
                            </div>
                        );
                    })}
                </div> */}

                {/* {props.invoice.tip && Number(props.invoice.tip.amount) !== 0 && (
                    <div className={clsx(commonClasses.flexRow, classes.boxTotal, classes.line)}>
                        <Typography className={commonClasses.typo18_400}>Tip</Typography>
                        {props.calculating ? (
                            <CalculatingSpinner />
                        ) : (
                            <Typography className={commonClasses.typo18_400}>{`${
                                props.invoice.tip?.percentage ? '(' + props.invoice.tip?.percentage + '%) ' : ''
                            }$${props.invoice.tip.amount}`}</Typography>
                        )}
                    </div>
                )} */}

                {/* <div className={clsx(commonClasses.flexRow, classes.boxTotal)}>
                    <Typography className={commonClasses.typo18_600}>Total</Typography>
                    {props.calculating ? (
                        <CalculatingSpinner />
                    ) : (
                        <Typography className={commonClasses.typo18_600}>${props.invoice.grandTotal}</Typography>
                    )}
                </div> */}
            </div>
        </>
    );
};
